<template>
    <div>

        <!-- Filter Start -->
        <div class="innerBox mb-4">
            <div class="row">
                <div class="col-md-2">
                    <a 
                        class="navbar-brand ml-3"
                        style="font: normal normal normal 16px/25px Poppins;">Cek Status Truk</a>
                </div>
                <div class="col-md-8">
                    <input
                        class="form-control filterInput"
                        type="search"
                        placeholder="Masukkan Nomor Polisi"
                        aria-label="Search"
                        style="display: flex; font: normal normal normal 16px/25px Poppins;"
                        v-model="filter.search"
                    >
                </div>
                <div 
                    class="col-md-2 text-right" 
                    style="display: flex; justify-content: flex-end">
                    <button
                        class="btn"
                        type="button"
                        style="
                            background-color: #1B698E; 
                            color: white; 
                            padding: 0 50px; 
                            height: 100%; 
                            font-weight: bold; 
                            display: flex; 
                            align-items: center; 
                            font: normal normal 600 14px/21px Poppins;"
                        @click="vue_universal_table.update++"
                    >CARI</button>
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <!-- Table Start -->
        <div class="innerBox">
            <div class="mb-4 row">
                <div class="col-md-12">
                    <h3 class="tableTitle" style="font: normal normal normal 16px/25px Poppins;">List Status Truck</h3>
                </div>
            </div>
            <vue-universal-table
                api_url="/api/monitoring/status-truk"
                :filter="filter"
                :fields="vue_universal_table.fields"
                :update="vue_universal_table.update"
                :process_data="vue_universal_table.process_data"
                :infinite_scroll="true"

                sort_order="ASC"
                sort_by="sj_total"
                style="font: normal normal normal 12px/18px Poppins;"
            ></vue-universal-table>
        </div>
        <!-- Table End -->
    </div>
</template>

<script>

export default {
    metaInfo : {
        title : 'Monitoring Status Truk'
    },
    data () {
        return {
            filter : {
                search : ''
            },
            vue_universal_table : {
                fields : [
                    {title:"NOPOL", variable:"nopol"},
                    {title:"SJ Total", variable:"sj_total"},
                    {title:"SJ Terkirim", variable:"jumlah_terkirim"},
                    {title:"Ekspedisi", variable:"ekspedisi"},
                    // {title:"RUTE", variable: null},
                    {title:"NO TO", variable:"no_to"},
                    {title:"NAMA DRIVER", variable:"driver"},
                    {title:"Status", variable: "status_pengiriman"},
                ],
                filter : {
                    search : null,
                },
                update : 0,
                process_data: `
                    for(var i in data) {
                        data[i].driver = data[i].driver.replace(/[^a-zA-Z0-9]/g, " ");
                    }
                `
            },
        }
    },
    mounted () {

    },
    methods : {

    }
}
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
        
    }

    .chart {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
        align-items: center;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .tableTitle {
        text-align: center;
    }

    /* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

    .stats--icon {
        display:flex; 
        align-items:center; 
        justify-content:center;
        text-align: center;
    }

    .table td, .table th{
        text-align: center;
    }
</style>